import React from 'react';

export interface Image {
  title: string;
  imageType?: string;
  transforms: Record<string, {
    url: string;
    width: string;
    height: string;
  }>;
}

interface PictureProps {
  image: Image;
  defaultTransform: string;
  loading: 'lazy' | 'eager';
  classes?: string | undefined;
  pictureClasses?: string | undefined;
}

export default function Picture(
  {
    image,
    defaultTransform,
    loading,
    classes,
    pictureClasses,
  }: PictureProps,
) {
  const media = {
    all: '',
    xs: '(max-width: 575px)',
    'xs-min': '(min-width: 576px)',
    sm: '(max-width: 767px)',
    'sm-min': '(min-width: 768px)',
    md: '(max-width: 991px)',
    'md-min': '(min-width: 992px)',
    lg: '(max-width: 1023px)',
    'lg-min': '(min-width: 1024px)',
    xl: '(max-width: 1199px)',
    'xl-min': '(min-width: 1200px)',
    '2xl': '(max-width: 1484px)',
    '2xl-min': '(min-width: 1485px)',
    '3xl': '(max-width: 1767px)',
    '4xl': '(min-width: 1768px)',
    '4k': '(min-width: 3840px)',
  };

  return (
    image && (
      <picture className={pictureClasses}>
        {Object.entries(media).map(([key, value]) => (
          (image.transforms[key]) && (
            <source
              media={value}
              srcSet={image.transforms[key]?.url}
              key={key}
              width={image.transforms[key]?.width}
              height={image.transforms[key]?.height}
            />
          )
        ))}
        <img
          src={image.transforms[defaultTransform]?.url}
          alt={image.title || ''}
          loading={loading}
          width={image.transforms[defaultTransform]?.width}
          height={image.transforms[defaultTransform]?.height}
          className={classes}
        />
      </picture>
    )
  );
}
